import { render, staticRenderFns } from "./CustomerNotes.vue?vue&type=template&id=2f11176a"
import script from "./CustomerNotes.vue?vue&type=script&lang=js"
export * from "./CustomerNotes.vue?vue&type=script&lang=js"
import style0 from "./CustomerNotes.vue?vue&type=style&index=0&id=2f11176a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports